import web1 from "../../assets/images/projects/web1.png"
import web2 from "../../assets/images/projects/web2.png"
import web3 from "../../assets/images/projects/web3.png"
import web4 from "../../assets/images/projects/web4.png"
import web5 from "../../assets/images/projects/web5.png"
import web6 from "../../assets/images/projects/web6.png"
import web7 from "../../assets/images/projects/web7.png"
import web8 from "../../assets/images/projects/web8.png"
import web9 from "../../assets/images/projects/web9.png"
import web10 from "../../assets/images/projects/web10.png"
import web11 from "../../assets/images/projects/web11.png"
import web12 from "../../assets/images/projects/web12.png"
import web13 from "../../assets/images/projects/web13.png"
import web14 from "../../assets/images/projects/web14.png"
import web15 from "../../assets/images/projects/web15.png"
import web16 from "../../assets/images/projects/web16.png"
import web17 from "../../assets/images/projects/web17.png"
import web18 from "../../assets/images/projects/web18.png"
import web19 from "../../assets/images/projects/web19.png"
import web20 from "../../assets/images/projects/web20.png"

import userinterface1 from "../../assets/images/projects/userinterface1.png"
import userinterface2 from "../../assets/images/projects/userinterface2.png"
import userinterface3 from "../../assets/images/projects/userinterface3.png"
import userinterface4 from "../../assets/images/projects/userinterface4.png"
import userinterface5 from "../../assets/images/projects/userinterface5.png"
import userinterface6 from "../../assets/images/projects/userinterface6.png"
import userinterface7 from "../../assets/images/projects/userinterface7.png"

import android1 from "../../assets/images/projects/android1.png"
import android2 from "../../assets/images/projects/android2.png"
import android3 from "../../assets/images/projects/android3.png"
import android4 from "../../assets/images/projects/android4.png"

import logo1 from "../../assets/images/projects/logo1.png"
import logo2 from "../../assets/images/projects/logo2.png"
import logo3 from "../../assets/images/projects/logo3.png"
import logo4 from "../../assets/images/projects/logo4.png"
import logo5 from "../../assets/images/projects/logo5.png"

import feeds1 from "../../assets/images/projects/feeds1.png"
import feeds2 from "../../assets/images/projects/feeds2.png"
import feeds3 from "../../assets/images/projects/feeds3.png"
import feeds4 from "../../assets/images/projects/feeds4.png"
import feeds5 from "../../assets/images/projects/feeds5.png"
import feeds6 from "../../assets/images/projects/feeds6.png"

import poster1 from "../../assets/images/projects/poster1.png"
import poster2 from "../../assets/images/projects/poster2.png"
import poster3 from "../../assets/images/projects/poster3.png"
import poster4 from "../../assets/images/projects/poster4.png"
import poster5 from "../../assets/images/projects/poster5.png"
import poster6 from "../../assets/images/projects/poster6.png"
import poster7 from "../../assets/images/projects/poster7.png"
import poster8 from "../../assets/images/projects/poster8.png"
import poster9 from "../../assets/images/projects/poster9.png"
import poster10 from "../../assets/images/projects/poster10.png"
import poster11 from "../../assets/images/projects/poster11.png"
import poster12 from "../../assets/images/projects/poster12.png"
import poster13 from "../../assets/images/projects/poster13.png"
import poster14 from "../../assets/images/projects/poster14.png"
import poster15 from "../../assets/images/projects/poster15.png"

import sertifikat1 from "../../assets/images/projects/sertifikat1.png"
import sertifikat2 from "../../assets/images/projects/sertifikat2.png"
import sertifikat3 from "../../assets/images/projects/sertifikat3.png"
import sertifikat4 from "../../assets/images/projects/sertifikat4.png"
import sertifikat5 from "../../assets/images/projects/sertifikat5.png"
import sertifikat6 from "../../assets/images/projects/sertifikat6.png"
import sertifikat7 from "../../assets/images/projects/sertifikat7.png"
import sertifikat8 from "../../assets/images/projects/sertifikat8.png"
import sertifikat9 from "../../assets/images/projects/sertifikat9.png"
import sertifikat10 from "../../assets/images/projects/sertifikat10.png"
import sertifikat11 from "../../assets/images/projects/sertifikat11.png"
import sertifikat12 from "../../assets/images/projects/sertifikat12.png"
import sertifikat13 from "../../assets/images/projects/sertifikat13.png"
import sertifikat14 from "../../assets/images/projects/sertifikat14.png"
import sertifikat15 from "../../assets/images/projects/sertifikat15.png"
import sertifikat16 from "../../assets/images/projects/sertifikat16.png"
import sertifikat17 from "../../assets/images/projects/sertifikat17.png"
import sertifikat18 from "../../assets/images/projects/sertifikat18.png"
import sertifikat19 from "../../assets/images/projects/sertifikat19.png"
import sertifikat20 from "../../assets/images/projects/sertifikat20.png"
import sertifikat21 from "../../assets/images/projects/sertifikat21.png"
import sertifikat22 from "../../assets/images/projects/sertifikat22.png"
import sertifikat23 from "../../assets/images/projects/sertifikat23.png"
import sertifikat24 from "../../assets/images/projects/sertifikat24.png"
import sertifikat25 from "../../assets/images/projects/sertifikat25.png"
import sertifikat26 from "../../assets/images/projects/sertifikat26.png"
import sertifikat27 from "../../assets/images/projects/sertifikat27.png"
import sertifikat28 from "../../assets/images/projects/sertifikat28.png"
import sertifikat29 from "../../assets/images/projects/sertifikat29.png"
import sertifikat30 from "../../assets/images/projects/sertifikat30.png"
import sertifikat31 from "../../assets/images/projects/sertifikat31.png"
import sertifikat32 from "../../assets/images/projects/sertifikat32.png"
import sertifikat33 from "../../assets/images/projects/sertifikat33.png"
import sertifikat34 from "../../assets/images/projects/sertifikat34.png"
import sertifikat35 from "../../assets/images/projects/sertifikat35.png"
import sertifikat36 from "../../assets/images/projects/sertifikat36.png"
import sertifikat37 from "../../assets/images/projects/sertifikat37.png"
import sertifikat38 from "../../assets/images/projects/sertifikat38.png"
import sertifikat39 from "../../assets/images/projects/sertifikat39.png"
import sertifikat40 from "../../assets/images/projects/sertifikat40.png"

import seminar1 from "../../assets/images/projects/seminar1.png"
import seminar2 from "../../assets/images/projects/seminar2.png"
import seminar3 from "../../assets/images/projects/seminar3.png"
import seminar4 from "../../assets/images/projects/seminar4.png"
import seminar5 from "../../assets/images/projects/seminar5.png"
import seminar6 from "../../assets/images/projects/seminar6.png"
import seminar7 from "../../assets/images/projects/seminar7.png"
import seminar8 from "../../assets/images/projects/seminar8.png"
import seminar9 from "../../assets/images/projects/seminar9.png"
import seminar10 from "../../assets/images/projects/seminar10.png"
import seminar11 from "../../assets/images/projects/seminar11.png"
import seminar12 from "../../assets/images/projects/seminar12.png"
import seminar13 from "../../assets/images/projects/seminar13.png"

import pembicara1 from "../../assets/images/projects/pembicara1.png"

import API1 from "../../assets/images/projects/API1.png"

export const projectsData = [
    {
        id: 1,
        src: web1,
        category: "Website",
        title: "Shoorai Construction",
    },
    {
        id: 2,
        src: web2,
        category: "Website",
        title: "Shoorai Technology Agency",
    },
    {
        id: 3,
        src: web3,
        category: "Website",
        title: "Mitra Tani Klaten",
    },
    {
        id: 4,
        src: web4,
        category: "Website",
        title: "Miliikody",
    },
    {
        id: 5,
        src: web5,
        category: "Website",
        title: "Dayak Ngaju",
    },
    {
        id: 6,
        src: web6,
        category: "Website",
        title: "CRUD Laravel",
    },
    {
        id: 7,
        src: web7,
        category: "Website",
        title: "Manajemen Buku Javascript",
    },
    {
        id: 8,
        src: web8,
        category: "Website",
        title: "Manajemen Catatan React Js",
    },
    {
        id: 9,
        src: web9,
        category: "Website",
        title: "CRUD MERN Stack",
    },
    {
        id: 10,
        src: userinterface1,
        category: "User Interface",
        title: "Portal UAD iOS Version",
    },
    {
        id: 11,
        src: userinterface2,
        category: "User Interface",
        title: "Sarwapalaka PKM-KC 2022",
    },
    {
        id: 12,
        src: userinterface3,
        category: "User Interface",
        title: "Ahmad Dahlan Education Expo",
    },
    {
        id: 13,
        src: userinterface4,
        category: "User Interface",
        title: "Bootcamp Myskill.id",
    },
    {
        id: 14,
        src: userinterface5,
        category: "User Interface",
        title: "Vaccine Apps",
    },
    {
        id: 15,
        src: userinterface6,
        category: "User Interface",
        title: "Marketplace",
    },
    {
        id: 16,
        src: userinterface7,
        category: "User Interface",
        title: "Use Case MSIB 6 HiColleagues",
    },
    {
        id: 17,
        src: android1,
        category: "Android",
        title: "Jetpack Compose Car BMW",
    },
    {
        id: 18,
        src: android2,
        category: "Android",
        title: "Story Apps",
    },
    {
        id: 19,
        src: android3,
        category: "Android",
        title: "Github API",
    },
    {
        id: 20,
        src: android4,
        category: "Android",
        title: "Lazy List Apps",
    },
    {
        id: 21,
        src: logo1,
        category: "Logo",
        title: "P2K Harmoni UAD 2023",
    },
    {
        id: 22,
        src: logo2,
        category: "Logo",
        title: "Wiklu Bites",
    },
    {
        id: 23,
        src: logo3,
        category: "Logo",
        title: "Mitra Tani Klaten",
    },
    {
        id: 24,
        src: logo4,
        category: "Logo",
        title: "Ekonomi Emporium (Ekorium)",
    },
    {
        id: 25,
        src: logo5,
        category: "Logo",
        title: "Capstone Bangkit Academy (BeFitOutfit)",
    },
    {
        id: 26,
        src: feeds1,
        category: "Feeds",
        title: "P2K Harmoni UAD 2023",
    },
    {
        id: 27,
        src: feeds2,
        category: "Feeds",
        title: "Ekonomi Emporium (Ekorium)",
    },
    {
        id: 28,
        src: feeds3,
        category: "Feeds",
        title: "HIPMI-PT UAD",
    },
    {
        id: 29,
        src: feeds4,
        category: "Feeds",
        title: "KBM Informatika UAD 2021",
    },
    {
        id: 30,
        src: poster1,
        category: "Poster",
        title: "Volunteer Harisenin.com"
    },
    {
        id: 31,
        src: poster2,
        category: "Poster",
        title: "Dies Natalis IIK Bhakti Wiyata Ke - 36"
    },
    {
        id: 32,
        src: poster3,
        category: "Poster",
        title: "Comday 9"
    },
    {
        id: 33,
        src: poster4,
        category: "Poster",
        title: "HUT HMTI Ke - 27"
    },
    {
        id: 34,
        src: poster5,
        category: "Poster",
        title: "Borneo Competition Telkom Regional VI (Kalimantan)"
    },
    {
        id: 35,
        src: poster6,
        category: "Poster",
        title: "Poster Edukasi 'Mengapa Aku Harus Kuliah?'"
    },
    {
        id: 36,
        src: feeds5,
        category: "Feeds",
        title: "Use Case MSIB 6 Feeds Dibimbing.id"
    },
    {
        id: 37,
        src: poster7,
        category: "Poster",
        title: "Westernisasi Semakin Cepat di Masa Pandemi"
    },
    {
        id: 38,
        src: poster8,
        category: "Poster",
        title: "Dayaknese"
    },
    {
        id: 39,
        src: poster9,
        category: "Poster",
        title: "Koperasi di Era Digital"
    },
    {
        id: 40,
        src: poster10,
        category: "Poster",
        title: "Vaksinasi Covid-19 Untuk Pemulihan Indonesia-ku"
    },
    {
        id: 41,
        src: poster11,
        category: "Poster",
        title: "Stunting"
    },
    {
        id: 42,
        src: poster12,
        category: "Poster",
        title: "Mitra Tani Klaten"
    },
    {
        id: 43,
        src: sertifikat1,
        category: "Certificate",
        title: "Memulai Pemrograman Dengan Kotlin"
    },
    {
        id: 44,
        src: sertifikat2,
        category: "Certificate",
        title: "Memulai Pemrograman dengan Python"
    },
    {
        id: 45,
        src: sertifikat3,
        category: "Certificate",
        title: "Belajar Dasar Pemrograman Javascript"
    },
    {
        id: 46,
        src: sertifikat4,
        category: "Certificate",
        title: "Belajar Dasar Pemrograman Web"
    },
    {
        id: 47,
        src: sertifikat5,
        category: "Certificate",
        title: "Belajar Membuat Front-End untuk Pemula"
    },
    {
        id: 48,
        src: sertifikat6,
        category: "Certificate",
        title: "Belajar Prinsip Pemrograman SOLID"
    },
    {
        id: 49,
        src: sertifikat7,
        category: "Certificate",
        title: "Belajar Dasar Git dengan Github"
    },
    {
        id: 50,
        src: sertifikat8,
        category: "Certificate",
        title: "Belajar Dasar Structured Query Language (SQL)"
    },
    {
        id: 51,
        src: sertifikat9,
        category: "Certificate",
        title: "Belajar Fundamental Aplikasi Android"
    },
    {
        id: 52,
        src: sertifikat10,
        category: "Certificate",
        title: "Memulai Dasar Pemrograman untuk Menjadi Pengembang Software"
    },
    {
        id: 53,
        src: sertifikat11,
        category: "Certificate",
        title: "Pengenalan ke Logika Pemrograman (Programming Logic 101)"
    },
    {
        id: 54,
        src: sertifikat12,
        category: "Certificate",
        title: "Belajar Pengembangan Aplikasi Android Intermediate"
    },
    {
        id: 55,
        src: sertifikat13,
        category: "Certificate",
        title: "Belajar Membuat Aplikasi Android dengan Jetpack Compose"
    },
    {
        id: 56,
        src: sertifikat14,
        category: "Certificate",
        title: "Belajar Dasar Manajemen Proyek"
    },
    {
        id: 57,
        src: sertifikat15,
        category: "Certificate",
        title: "Belajar Dasar Data Science"
    },
    {
        id: 58,
        src: sertifikat16,
        category: "Certificate",
        title: "Memulai Pemrograman Dengan C"
    },
    {
        id: 59,
        src: sertifikat17,
        category: "Certificate",
        title: "Belajar Membuat Aplikasi Android untuk Pemula"
    },
    {
        id: 60,
        src: sertifikat18,
        category: "Certificate",
        title: "Belajar Dasar AI"
    },
    {
        id: 61,
        src: sertifikat19,
        category: "Certificate",
        title: "Belajar Membuat Aplikasi Web dengan React"
    },
    {
        id: 62,
        src: sertifikat20,
        category: "Certificate",
        title: "Introduction to Figma"
    },
    {
        id: 63,
        src: sertifikat21,
        category: "Certificate",
        title: "Bangkit Academy - Mobile Development"
    },
    {
        id: 64,
        src: sertifikat22,
        category: "Certificate",
        title: "Introduction to React"
    },
    {
        id: 65,
        src: sertifikat23,
        category: "Certificate",
        title: "Basic Concept React"
    },
    {
        id: 66,
        src: sertifikat24,
        category: "Certificate",
        title: "Intro to Data Analytics"
    },
    {
        id: 67,
        src: sertifikat25,
        category: "Certificate",
        title: "Juara 1 Poster IIK Bhakta Wiyata Kediri ke - 36 tahun"
    },
    {
        id: 68,
        src: sertifikat26,
        category: "Certificate",
        title: "Juara 1 Comday 9 HIMAKOM UAD 2021"
    },
    {
        id: 69,
        src: sertifikat27,
        category: "Certificate",
        title: "Juara 2 Poster HMTI Ke - 27 UAD"
    },
    {
        id: 70,
        src: sertifikat28,
        category: "Certificate",
        title: "30 Besar Poster Telkom Regional VI (Kalimantan)"
    },
    {
        id: 71,
        src: sertifikat29,
        category: "Certificate",
        title: "Juara 2 Lomba Poster Edukatif 'Mengapa Aku Harus Kuliah' Tingkat Nasional"
    },
    {
        id: 72,
        src: API1,
        category: "API",
        title: "API CRUD MERN Stack (Using Express.Js)"
    },
    {
        id: 73,
        src: feeds6,
        category: "Feeds",
        title: "Volunteer Harisenin.com"
    },
    {
        id: 74,
        src: poster13,
        category: "Poster",
        title: "HIPMI-PT UAD"
    },
    {
        id: 75,
        src: poster14,
        category: "Poster",
        title: "Ekonomi Emporium (Ekorium)"
    },
    {
        id: 76,
        src: poster15,
        category: "Poster",
        title: "P2K Harmoni UAD 2023"
    },
    {
        id: 77,
        src: web10,
        category: "Website",
        title: "Portfolio Website (React Js)"
    },
    {
        id: 78,
        src: web11,
        category: "Website",
        title: "Pokemon Skilvul (React + Vite)",
    },
    {
        id: 79,
        src: web12,
        category: "Website",
        title: "My First Web Portfolio (Shoorai Business)",
    },
    {
        id: 80,
        src: web13,
        category: "Website",
        title: "QuizApp Dot Indonesia",
    },
    {
        id: 81,
        src: web14,
        category: "Website",
        title: "NotesApp Theme API",
    },
    {
        id: 82,
        src: sertifikat30,
        category: "Certificate",
        title: "Hustler Mentee Digistar by Telkom Indonesia"
    },
    {
        id: 83,
        src: sertifikat31,
        category: "Certificate",
        title: "Frontend Developer (React)"
    },
    {
        id: 84,
        src: sertifikat32,
        category: "Certificate",
        title: "Software Engineer"
    },
    {
        id: 85,
        src: sertifikat33,
        category: "Certificate",
        title: "Belajar Fundamental Aplikasi Web dengan React"
    },
    {
        id: 86,
        src: sertifikat34,
        category: "Certificate",
        title: "Software Engineer Intern"
    },
    {
        id: 87,
        src: sertifikat35,
        category: "Certificate",
        title: "Problem Solving (Basic)"
    },
    {
        id: 88,
        src: sertifikat36,
        category: "Certificate",
        title: "React (Basic)"
    },
    {
        id: 89,
        src: sertifikat37,
        category: "Certificate",
        title: "Membangun Potensi, Jelajahi Karir Unggul di Industri IT"
    },
    {
        id: 90,
        src: seminar1,
        category: "Seminar/Webinar",
        title: "Let's Be Aware of Depression by CIMSA UGM"
    },
    {
        id: 91,
        src: seminar2,
        category: "Seminar/Webinar",
        title: "International Guest Lecture in Marketing and Organizational Communication"
    },
    {
        id: 92,
        src: seminar3,
        category: "Seminar/Webinar",
        title: "Education Fair 2023"
    },
    {
        id: 93,
        src: seminar4,
        category: "Seminar/Webinar",
        title: "Form Zero to Hero: Building a Solid Financial Foundation for your Future"
    },
    {
        id: 94,
        src: seminar5,
        category: "Seminar/Webinar",
        title: "[Offline] IDCamp Connect Roadshow - Solo"
    },
    {
        id: 95,
        src: seminar6,
        category: "Seminar/Webinar",
        title: "[Offline Event] Baparekraf Developer Day 2024"
    },
    {
        id: 96,
        src: seminar7,
        category: "Seminar/Webinar",
        title: "IDCamp x Dicoding Live #1 - Beyond the Basics: Elevate Your Career as a Full Stack Developer in 2024"
    },
    {
        id: 97,
        src: seminar8,
        category: "Seminar/Webinar",
        title: "IDCamp x Dicoding Live #2 - Automation: Fast Track Your Career with UiPath and Meet MVP UiPath"
    },
    {
        id: 98,
        src: seminar9,
        category: "Seminar/Webinar",
        title: "IDCamp x Dicoding Live #1 - Beyond the Basics: Elevate Your Career as a Full Stack Developer in 2024"
    },
    {
        id: 99,
        src: seminar10,
        category: "Seminar/Webinar",
        title: "DevCoach 158 : ML Android | Buat Aplikasi Androidmu Naik Kelas dengan Generative AI"
    },
    {
        id: 100,
        src: seminar11,
        category: "Seminar/Webinar",
        title: "DevCoach 176: React | Cara Jitu React Membangun UI"
    },
    {
        id: 101,
        src: seminar12,
        category: "Seminar/Webinar",
        title: "DevCoach 122 : Back-End | Mengimplementasikan Autentikasi dan Otorisasi pada REST API"
    },
    {
        id: 102,
        src: seminar13,
        category: "Seminar/Webinar",
        title: "IDCamp x Dicoding Live #3 - Automation and AI Trends: How They Are Shaping the Future"
    },
    {
        id: 103,
        src: pembicara1,
        category: "Pembicara",
        title: "Fasilitator UAD MSIB CAMP"
    },
    {
        id: 104,
        src: web15,
        category: "Website",
        title: "Neutron Filtering",
    },
    {
        id: 105,
        src: web16,
        category: "Website",
        title: "Neon Uji Dashboard 2.0",
    },
    {
        id: 106,
        src: web17,
        category: "Website",
        title: "LabDLHK Kab.Kapuas",
    },
    {
        id: 107,
        src: web18,
        category: "Website",
        title: "Horus Technology Exam",
    },
    {
        id: 108,
        src: sertifikat38,
        category: "Certificate",
        title: "IDCamp React Intermediate"
    },
    {
        id: 109,
        src: sertifikat39,
        category: "Certificate",
        title: "LandingPage Builder Internship"
    },
    {
        id: 110,
        src: sertifikat40,
        category: "Certificate",
        title: "Front-End Developer Internship"
    },
    {
        id: 111,
        src: web19,
        category: "Website",
        title: "Qiscus Chat Apps",
    },
    {
        id: 112,
        src: web20,
        category: "Website",
        title: "Study.io Dashboard",
    },
]